import { ComponentProps, ComponentType, lazy } from 'react';

import { useSuspendedUIDelay } from 'hooks/useDelay';

import { ClientOnlySuspense } from './ClientOnlySuspense';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Args<T extends ComponentType<any>> = {
  loader: () => Promise<{ default: T }>;
  // TODO: remove <any> and update loading components to not receive any props
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  loading: ComponentType<any>;
  delayedFallback?: boolean;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function clientOnlyLazy<T extends ComponentType<any>>({
  loader,
  loading: Loading,
  delayedFallback,
}: Args<T>) {
  const Component = lazy(loader);

  return function ClientOnlySuspenseWrapper(props: ComponentProps<T>) {
    const { pastDelay } = useSuspendedUIDelay();

    return (
      <ClientOnlySuspense
        fallback={!delayedFallback || pastDelay ? <Loading /> : null}
      >
        <Component
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      </ClientOnlySuspense>
    );
  };
}
